import ActivityFormService from 'api/activities/activityFormService.js';

const markAsDoneWithNewForm = ({ callback, id, date, description }) => {
    Popup.openPopup({
        key: 'popupMarkPhoneCallDone',
        props: {
            idPhoneCall: id,
            description,
            callback,
            date,
        },
    });
};
const markAsTodoWithNewForm = ({ id }) => {
    const phoneCallFormService = new ActivityFormService('phonecall');
    return new Promise((resolve, reject) => {
        phoneCallFormService
            .updateActivity({
                id,
                result: 'scheduled',
            })
            .then(() => {
                window.sellsyapp.$pushToast({
                    type: 'success',
                    icon: true,
                    close: true,
                    text: window.sellsyapp.$t.__('activities.markAsTodo.success'),
                });
                resolve();
            })
            .catch(() => {
                window.sellsyapp.$pushToast({
                    type: 'error',
                    icon: true,
                    close: true,
                    text: this.$t.__(
                        'activities.detailPanel.ActivityDetailPanel.errorUpdateStatus',
                    ),
                });
                reject();
            });
    });
};

export { markAsDoneWithNewForm, markAsTodoWithNewForm };
